export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fedf927aab3e6fc84f29786f48b5fa0602d7a73ab&name=fetchTypeahead!'